/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-05 15:48:34
 */
import {
  InitDictionariesdata,
  InitDictionariesdataProps,
} from "@root/actions/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: InitDictionariesdataProps = InitDictionariesdata;

export const userSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {
    setDictionaries: (
      state,
      action: PayloadAction<InitDictionariesdataProps>
    ) => {
      state = action.payload;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
const { actions, reducer } = userSlice;
export const { setDictionaries } = actions;
export default reducer;
